import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';

//  Services
import { StorageService } from './storage.service';

@Injectable()
export class HttpService {

    constructor(private http: Http, public storageService: StorageService) { }

    addRequestHeaders(headers: Headers, type: string) {
        switch (type) {
            case 'json':
            this.createApplicationJsonHeader(headers);
            break;
            case 'urlencoded':
            this.createFormUrlEncodedHeader(headers);
            break;
        }
    }

    createAuthorizationHeader(headers: Headers) {

        var session = this.storageService.retrieve('session');

        if (!session) return;

        headers.append('Authorization', 'Bearer ' + session.access);
    }

    createFormUrlEncodedHeader(headers: Headers) {
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
    }

    createApplicationJsonHeader(headers: Headers) {
        headers.append('Content-Type', 'application/json');
    }

    GET(url, secured: boolean) {

        let headers = new Headers();

        this.createAuthorizationHeader(headers);

        return this.http.get(url, {
            headers: headers
        });
    }

    POST(url: string, contentType: string, data: any, secured: boolean) {

        let headers = new Headers();

        this.addRequestHeaders(headers, contentType);

        if (secured) this.createAuthorizationHeader(headers);

        return this.http.post(url, data, {
            headers: headers
        });
    }

    PUT(url, contentType, data, secured: boolean) {

        let headers = new Headers();

        this.addRequestHeaders(headers, contentType);

        if (secured) this.createAuthorizationHeader(headers);

        return this.http.put(url, data, {
            headers: headers
        });
    }

    DELETE(url, secured: boolean) {

        let headers = new Headers();

        this.createAuthorizationHeader(headers);

        return this.http.delete(url, {
            headers: headers
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/http.service.ts